// extracted by mini-css-extract-plugin
module.exports = {"Burger":"burger_Burger__1FaX7"};